module.exports = __webpack_public_path__ + "img/pearl-river_banner.ff88f6ff.jpg";